/*export const SERVICE_FORM_URL = '/service-form/';
export const SIGN_UP_URL = '/signup/';
export const HOME_URL = '/';
export const SIGN_IN_URL = '/signin';*/

export const NavigationUrls = {
    SERVICE_FORM_URL: '/service-form/',
    SIGN_UP_URL: '/signup/',
    HOME_URL: '/home',
    SIGN_IN_URL: '/signin',
    SERVICES_FORM_URL: '/services/',
    TRIAL_SUBSCRIPTIONS_URL: '/trial-subscriptions',
    ADD_SUBSCRIPTION: '/add-seller-subscription',
    ADD_COMMISSION_ONLY_SUBSCRIPTION: '/add-commission-only-seller-subscription',
    ACCOUNTS_DASHBOARD:'/accounts-dashboard',
    REQUEST_DASHBOARD:'/request-dashboard',
    USERS_FILLRATE_DASHBOARD:'/users-fill-rate',
    REQUESTS_URL: '/',
    SUBSCRIPTION_SEARCH: '/subscriptions/search',
    SUBSCRIPTION_SEARCH_WITH_ID: '/subscriptions/search/:sellerID',
    CHURN_CANDIDATES: '/subscriptions/churn-candidates',
    USERS_WEEKLY_FILLRATE:'/users-weekly-fill-rate', 
    AM_DASHBOARD: '/am-dashboard',  
    COMMISSION_PAYMENTS: '/commission-payments',
    PAYMENT_PLANS: '/payment-plans',
    IMPERSONATE_USER: '/impersonate-user',
    RADIUS_CHECK: '/radius-check',
    ACTUAL_COMMISSION_REVENUE: '/lead-fee-revenue',
    SET_SELLER_PWD: '/set-seller-pwd',
    SELLER_LIST_BY_ACCEPTING_JOB: '/accepting-jobs',
    SELLER_CATEGORY_RADIUS: '/seller-category-radius',
    SAAS_METRICS: '/saas-metrics'
}